import { ExpirationType, OptionExpirationType } from '@tradingblock/types';
import dayjs from 'dayjs';
import LocalizedFormat from 'dayjs/plugin/localizedFormat';
import utc from 'dayjs/plugin/utc';
import { populateTimeZones, findTimeZone, convertTimeToDate } from 'timezone-support/dist/lookup-convert';
import * as tzdata from 'timezone-support/dist/data-2012-2022';
import { convertDateToTime } from 'timezone-support';
import customParseFormat from 'dayjs/plugin/customParseFormat';
dayjs.extend(customParseFormat);
populateTimeZones(tzdata);
dayjs.extend(LocalizedFormat);
dayjs.extend(utc);
function isDayjs(d) {
    if (d === undefined) {
        return false;
    }
    return dayjs.isDayjs(d);
}
export const getLocalDateFromTimezone = (date) => {
    const tz = findTimeZone(timeZone);
    const dateVal = isDayjs(date) ? date.toDate() : date || new Date();
    const localDate = tz ? convertTimeToDate(convertDateToTime(dateVal)) : dateVal;
    return dayjs(localDate);
};
export const getWeekdayOfMonth = (date, dayOfWeek, weekOfMonth) => {
    const firstDayOfMonth = dayjs(date).date(1);
    // start on 1st of month, then set day of week (starts at 'Sunday' === 0)
    const firstDayOfWeek = dayjs(firstDayOfMonth).day(dayOfWeek);
    // add extra week if setting day of week above shifted to previous month
    const weeksToAdd = firstDayOfWeek.isBefore(firstDayOfMonth) ? weekOfMonth + 1 : weekOfMonth;
    // shift date to week of the month (one less since starting in first week)
    return firstDayOfWeek.add(weeksToAdd - 1, 'week');
};
export const getExpirationType = (date) => {
    // monthly expirations are on 3rd friday of the month ('Friday' === 5)
    const dateValue = dayjs.isDayjs(date) ? date.toDate() : date;
    const monthlyExpiration = getWeekdayOfMonth(dateValue, 5, 3);
    return dayjs(dateValue).isSame(monthlyExpiration, 'date') ? ExpirationType.Monthly : ExpirationType.Weekly;
};
export const formatExpiration = (dto) => {
    const date = dayjs(dto.Date).toDate();
    const isWeekly = dto.ExpirationFreqCode === 'W' ||
        dto.ExpirationFreqCode === 'MW' ||
        dto.ExpirationFreqCode === 'WW' ||
        dto.ExpirationFreqCode.includes('Week') ||
        dto.ExpirationFreqCode.includes('W') ||
        dto.ExpirationFreqCode === 'ME';
    const isQuarterly = dto.ExpirationFreqCode === 'QuarterlyEOM';
    return Object.assign({}, dto, { date, type: isWeekly ? ExpirationType.Weekly : isQuarterly ? ExpirationType.Quarterly : ExpirationType.Monthly, optionExpirationType: dto.Time, rootSymbol: dto.RootSymbol });
};
export const toExpiration = (date, rootSymbol, optionExpirationType) => {
    return {
        date,
        type: getExpirationType(date),
        optionExpirationType: optionExpirationType || OptionExpirationType.PM,
        rootSymbol: rootSymbol,
    };
};
export const toShort = (date) => {
    return (isDayjs(date) ? date : dayjs(date)).format('MMM D, YYYY');
};
export const ToUtcMidnight = (date) => dayjs(date || new Date())
    .set('hour', 0)
    .set('minute', 0)
    .set('second', 0);
export const isBetweenInclusive = (date, startDate, endDate) => {
    if (date) {
        const d = dayjs(date);
        return ((d.isAfter(startDate, 'date') && d.isBefore(endDate, 'date')) ||
            d.isSame(startDate, 'date') ||
            d.isSame(endDate, 'date'));
    }
    return false;
};
export const isDateBetweenExclusive = (date, startDate, endDate) => {
    if (date) {
        const d = dayjs(date);
        return d.isAfter(startDate, 'date') && d.isBefore(endDate, 'date');
    }
    return false;
};
export const isBefore = (curr, date) => {
    const compDate = dayjs.isDayjs(date) ? date.toDate() : date;
    return curr ? dayjs(curr).isBefore(compDate, 'date') : false;
};
export const TodayDate = () => dayjs(new Date())
    .hour(0)
    .toDate();
export const isToday = (curr) => {
    return curr ? dayjs(curr).isSame(TodayDate(), 'date') : false;
};
// TODO: type fix
export const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
//# sourceMappingURL=DateUtilities.js.map